import {
  Box, Button, Checkbox, FormControl, Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger, Radio, RadioGroup, Select, Spinner, Stack, Text, Tooltip
} from '@chakra-ui/react'
import { AddonProduct, Offer } from 'brokertslib/src/dtos/Offer'
import { Error } from 'brokertslib/src/dtos/Error'
import { Insurer, Risk, RiskVariant, Selection, SelectionType } from 'brokertslib/src/enums'
import { useContext, useEffect, useState } from 'react'

import { FormLabel } from '../../../../components/FormLabel'
import { useGetAddonParamValues, useInsurerPaymentFrequencies, useSelections } from '../../../../hooks'
import { Loading } from '../../../../components/Loading'
import { Alert, LabelHintIcon, Percent, Search } from '../../../../icons'
import { formatPrice } from 'BrokerTsLib/src/Utils/formatPrice'
import { useGetOfferAvailableDiscounts, useGetOfferCkp, useSetOfferPaymentFrequency } from '../../../../hooks/useOffer'
import { insuranceParamsContext } from '../../../../layouts/Wizard'
import { InsuranceParamsDto, Item } from 'BrokerTsLib/src/dtos'
import moment from 'moment'
import { useChangePrice, useSelectOfferAddon } from '../../../../hooks/useOfferAddon'
import { EditableTotal, EditableTotalProps } from '../../../EditableTotal'
import { carkulkaOffersContext } from '../../../../context/CarkulkaOffersProvider'
import { carkulkaExtraOffersContext } from '../../../../context/CarkulkaExtraOffersProvider'

const InsuranceInfo = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { base: '1fr', lg: '1fr 1fr' },
        alignContent: 'start',
        w: '100%',
        columnGap: 8,
        rowGap: 2,
      }}
    >
      {children}
    </Box>
  )
}

const CKPInfo = ({ offerId }: { offerId: number }) => {
  const { mutateAsync: getCkp, isLoading: isLoading, data: ckp } = useGetOfferCkp(offerId)

  useEffect(() => { getCkp() }, []) // Požadavek CARKULKA-1673 - data se mají načítat ihned po zobrazení nabídky

  const showWarning = !isLoading && ckp?.data &&
    !ckp.data.message && (ckp.data.ckpMonths ?? -1) == 0
  const showError = !isLoading && ckp?.data && !ckp.data.message && ckp.data.ckpMonths == undefined

  let colorScheme = isLoading ? 'gray' : 'green';
  let rightIcon = <></>
  if (showWarning) {
    colorScheme = 'yellow'
    rightIcon = <Alert color="yellow.500" />
  }
  if (showError) {
    colorScheme = 'red'
    rightIcon = <Alert color="red.500" />
  }

  return (
    <Popover>
      <PopoverTrigger>
        <Button variant="outline" colorScheme={colorScheme} onClick={() => { /*getCkp()*/ }}>
          <Search color="secondary.500" />
          ČKP
          {rightIcon && rightIcon}
          {isLoading && <Spinner />}
        </Button>
      </PopoverTrigger>

      <PopoverContent>
        <PopoverArrow />

        <PopoverHeader sx={{ fontWeight: '600' }}>Bonus POV</PopoverHeader>

        <PopoverBody>
          {isLoading && <Loading />}
          {!isLoading && ckp?.data && !ckp.data.message && (ckp.data?.ckpMonths ?? 0) > 0 &&
            <Text>
              Bezeškodní průběh (dle ČKP). Celková doba pojištění: {ckp?.data.ckpMonths} měsíců, počet pojistných událostí {ckp?.data.ckpClaims}.
            </Text>
          }

          {!isLoading && showWarning &&
            <Text>
              Informace z ČKP byly načteny, ale jsou 0, překontrolujte si údaje o klientovi.
            </Text>
          }

          {!isLoading && ckp?.data && ckp.data.message &&
            <Text>{ckp.data.message}</Text>
          }
          {!isLoading && showError &&
            <Box sx={{ display: 'grid', gap: 2, justifyContent: 'start' }}>
              <Text sx={{ color: 'red.800' }}>Nepodařilo se načíst data z ČKP</Text>
            </Box>
          }
        </PopoverBody>
      </PopoverContent >
    </Popover >
  )
}





//const CKPInfo = () => {
//    const [ckpInfo, setCkpInfo] = useState<ICkpInfo>({
//        loading: false,
//        status: null,
//        message: null,
//    })
//    const toast = useToast()
//    let colorScheme = 'gray'
//    let rightIcon = <></>
//    let tooltipLabel = ckpInfo.message || null

//    switch (ckpInfo.status) {
//        case 'error':
//            colorScheme = 'red'
//            break
//        case 'success':
//            colorScheme = 'green'

//            break
//        case 'warning':
//            colorScheme = 'yellow'
//            break
//        default:
//            colorScheme = 'gray'
//    }

//    switch (ckpInfo.status) {
//        case 'error':
//            rightIcon = <Alert color="red.500" />
//            break
//        case 'warning':
//            rightIcon = <Alert color="yellow.500" />
//            break
//    }

//    const handleLoadCKP = () => {
//        // if (ckpInfo.message && ckpInfo.status !== 'error') {
//        //   return false
//        // }

//        setCkpInfo({
//            ...ckpInfo,
//            loading: true,
//            message: null,
//        })

//        loadCKPInfo()
//            .then((info) => {
//                setCkpInfo({
//                    ...ckpInfo,
//                    loading: false,
//                    status: info.status,
//                    message: info.message,
//                })
//            })
//            .catch(() => {
//                toast({
//                    title: 'Chyba při načítání informací z ČKP',
//                    status: 'error',
//                    duration: 5000,
//                    isClosable: true,
//                })
//            })
//    }

//    return (
//        <Popover>
//            <PopoverTrigger>
//                <Button variant="outline" colorScheme={colorScheme} onClick={handleLoadCKP}>
//                    <Tooltip label={tooltipLabel} hasArrow placement="top">
//                        <Flex sx={{ display: 'flex', gap: 2 }}>
//                            <Search color="secondary.500" />
//                            ČKP
//                            {rightIcon && rightIcon}
//                        </Flex>
//                    </Tooltip>
//                </Button>
//            </PopoverTrigger>

//            <PopoverContent>
//                <PopoverArrow />

//                <PopoverHeader sx={{ fontWeight: '600' }}>Bonus POV</PopoverHeader>

//                <PopoverBody>
//                    {ckpInfo.loading && <Loading />}

//                    {!ckpInfo.loading && ckpInfo.status === 'error' && (
//                        <Box sx={{ display: 'grid', gap: 2, justifyContent: 'start' }}>
//                            <Text sx={{ color: 'red.800' }}>{ckpInfo.message}</Text>
//                            <Button size="md" variant="outline" onClick={handleLoadCKP}>
//                                <Refresh color="secondary.500" />
//                                Zkuste to znova
//                            </Button>
//                        </Box>
//                    )}

//                    {!ckpInfo.loading && ckpInfo.status !== 'error' && <Text>{ckpInfo.message}</Text>}
//                </PopoverBody>
//            </PopoverContent>
//        </Popover>
//    )
//}




const InsuranceInfoItem = ({
  label,
  name,
  price,
  tooltip,
  notAvailable,
  emptyChar
}: {
  label: string
  name: string
  price?: number
  tooltip?: string
  notAvailable?: boolean
  emptyChar?: string
}) => {
  return (
    <Box sx={{ display: 'grid', gap: { base: 1, lg: 2 } }}>
      <Stack direction='row'>
        <Text sx={{ lineHeight: '1rem' }}>
          {label}
        </Text>

        {tooltip && (
          <Tooltip hasArrow placement="top" label={<Box dangerouslySetInnerHTML={{ __html: tooltip }}></Box>}>
            <Box sx={{ lineHeight: 0 }}>
              <LabelHintIcon width={4} height={4} />
            </Box>
          </Tooltip>
        )}
      </Stack>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 2,
          bgColor: 'gray.100',
          borderRadius: 'base',
          lineHeight: '1.25rem',
        }}
      >
        <Text sx={{ fontSize: 'sm', fontWeight: 'semibold' }}>{name}</Text>
        <Text sx={{ fontWeight: 'semibold' }}>{formatPrice({ price, notAvailable, emptyChar })}</Text>
      </Box>
    </Box>
  )
}

const ExtraInsurance = ({ children }: { children: React.ReactNode }) => {
  return <Box sx={{ display: 'grid', gap: 1 }}>{children}</Box>
}

const ExtraInsuranceItem = ({ name, price, valid, errors, editableProps, hidePrice }:
  { name: string | React.ReactNode; price?: number; valid: boolean; errors: Error[] | undefined, editableProps?: EditableTotalProps, hidePrice?: boolean }) => {
  const hasError = errors && errors.length > 0
  const errMsg = hasError ? errors?.map(e => e.message).join('<br/>') : ''

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      {typeof name === 'string' && <Text>{name}</Text>}
      {typeof name !== 'string' && <Box>{name}</Box>}
      <Stack direction='row'>
        {editableProps?.isEditable && valid &&
          <EditableTotal
            {...editableProps}
            price={price}
            size="sm"
            fontWeight='medium'
            color="transparent"
          />
        }

        {!editableProps?.isEditable && valid && !hidePrice &&
          <Text sx={{ fontWeight: 'medium' }}>{formatPrice({ price })}</Text>
        }

        {!valid && !hidePrice &&
          <>
            <Text variant={'danger'} sx={{ fontWeight: 'medium', lineHeight: '1rem' }}>nelze sjednat</Text>
            {hasError &&
              <Tooltip hasArrow placement="top" label={<Box dangerouslySetInnerHTML={{ __html: errMsg }}></Box>}>
                <Box sx={{ lineHeight: 0 }}>
                  <LabelHintIcon width={4} height={4} />
                </Box>
              </Tooltip>
            }
          </>
        }
      </Stack>
    </Box>
  )
}

const ControlsTotals = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        rowGap: 4,
      }}
    >
      {children}
    </Box>
  )
}

const Controls = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        alignItems: 'end',
        columnGap: 4,
        rowGap: 2,
      }}
    >
      {children}
    </Box>
  )
}

const Totals = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        rowGap: { base: 2, lg: 2 },
      }}
    >
      {children}
    </Box>
  )
}

const Total = ({
  label,
  size = 'md',
  color = 'gray.100',
  price,
}: {
  label: string
  size?: string
  color?: string
  price: number
}) => {
  return (
    <Box sx={{ display: 'grid', gap: 2 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 2,
          bgColor: color,
          borderRadius: 'base',
          lineHeight: '1.25rem',
        }}
      >
        <Text sx={{ fontSize: 'base' }}>{label}</Text>
        <Text sx={{ fontSize: size === 'lg' ? 'xl' : 'base', fontWeight: 'semibold' }}>
          {formatPrice({ price })}
        </Text>
      </Box>
    </Box>
  )
}

export const BasicInfoTab = ({ offer, color }: { offer: Offer, color: string }) => {
  if (offer.insurerId == Insurer.Allianz) {
    // nová služba Allianz nevrací ceny jednotlivých rizik, ale pouze celkovou cenu
    // nahradíme ceny za undefined aby se nezobrazovaly jako "zdarma"
    offer.parts.forEach(part => {
      if (part.price == 0) {
        part.price = undefined
      }
    })
  }

  const povPart = offer.parts.find(x => x.riskId === Risk.POV)
  const havPart = offer.parts.find(x => x.riskId === Risk.HAV)
  let spolPartName = offer.parts.find(x => x.riskId === Risk.SPOL)?.name
  if (havPart && havPart.name && spolPartName) {
    if (havPart.name.toLowerCase().indexOf('spoluúčast') >= 0)
      spolPartName = undefined;
  }

  const { data: dataPf, isLoading: isLoadingPf, isFetching: isFetchingPf } = useInsurerPaymentFrequencies()

  const { mutateAsync: getAddonParamValues } = useGetAddonParamValues()
  const { mutateAsync: selectOfferAddon } = useSelectOfferAddon()
  const { mutateAsync: updatePaymentFrequency } = useSetOfferPaymentFrequency()
  const { recalculateOffers: recalculate } = useContext(carkulkaOffersContext)
  const { offers: addonOffers, refetchOffers: refetchAddonOffers, updateOffer: updateAddonOffer } = useContext(carkulkaExtraOffersContext)
  const { insuranceParams } = useContext(insuranceParamsContext)
  const isContracted = !!insuranceParams?.generalParams.contractNumber

  const { mutateAsync: changePrice } = useChangePrice()
  const { data: discounts, refetch: getDiscounts } = useGetOfferAvailableDiscounts(offer.offerId, { enabled: false })
  useEffect(() => {
    getDiscounts()
  }, []);

  const gapPart = offer.parts.find(x => x.riskId == Risk.GAP)
  // pro Allianz není GAP part, je třeba ověřit, že varianta je Allrisk+GAP
  const offerVariantWithGap = (insuranceParams as InsuranceParamsDto)?.baseParams?.variants?.
    find(x => x.id == offer.insuranceVariantId && (x.variantParts?.findIndex(vp => vp.riskVariant == RiskVariant.AllriskPlusGAP) ?? -1) >= 0)
  // speciální kasko part pro Allianz obsahující GAP .. má se nabízet pouze navazující GAP
  const allianzKaskoWithGapPart = offer.parts.find(x => x.riskId == Risk.HAV && (x.description?.indexOf('Doplatek na nové (GAP)') ?? -1) > 0)
  // speciální kasko part pro Allianz bez GAPu .. má se nabízet poze nahrazující GAP
  const allianzKaskoWithoutGapPart = offer.parts.find(x => x.riskId == Risk.HAV && (x.description?.indexOf('Bez pojištění GAP') ?? -1) > 0)
  const allGapOffers = addonOffers.filter(x => x.riskId == Risk.GAP) ?? []
  const defendGapEditPriceTooltip = 'Nastavení ceny má vliv na provizi, při zadání nejnižší možné částky je provize 0%'

  var followingGapOffers = allGapOffers.filter(x => x.params?.isFollowGap)
  var followingGapOffer = followingGapOffers.find(x => x.linkedOfferId?.includes(offer.offerId) ?? false)
    ?? (followingGapOffers.find(x => (60 - parseInt(x.params?.parameterValues.find(p => p.name == 'Term')?.value ?? '0')) == (gapPart?.term ?? 0))
      ?? (followingGapOffers.length > 0 ? followingGapOffers[0] : null))

  var replacingGapOffers = allGapOffers.filter(x => !x.params?.isFollowGap)
  var replacingGapOffer = replacingGapOffers.find(x => x.linkedOfferId?.includes(offer.offerId) ?? false)
    ?? (replacingGapOffers.find(x => x.params?.parameterValues.find(p => p.name == 'Term')?.value == gapPart?.term)
      ?? (replacingGapOffers.length > 0 ? replacingGapOffers[0] : null))

  var insurancePramsDto = insuranceParams as InsuranceParamsDto
  var gapVariantSelected = insurancePramsDto.baseParams.addonVariants?.find((x) => x.riskVariantId == RiskVariant.AddonGAP)?.selected ?? false

  const [gapType, setGapType] = useState<'following' | 'replacing'>((replacingGapOffer?.linkedOfferId?.includes(offer.offerId) ?? false) ? 'replacing' : 'following');
  const [checkedFollowingGap, setCheckedFollowingGap] = useState(followingGapOffer?.linkedOfferId?.includes(offer.offerId) ?? false);
  const [checkedAllianzReplacingGap, setCheckedAllianzReplacingGap] = useState(replacingGapOffer?.linkedOfferId?.includes(offer.offerId) ?? false);
  const [isLoadingGapOffers, setIsLoadingGapOffers] = useState(false);

  const [followingGapPossibleTerms, setFollowingGapPossibleTerms] = useState<AddonProduct[]>([]);
  const [replacingGapPossibleTerms, setNotFollowingGapPossibleTerms] = useState<AddonProduct[]>([]);

  let allowedPf: Item[] = []
  if (dataPf && !isLoadingPf && !isFetchingPf) {
    allowedPf = dataPf.data.find(ipf => ipf.insurerId == offer.insurerId)?.paymentFrequencies ?? []
  }

  useEffect(() => {
    if (followingGapOffer)
      getAddonParamValues({
        mainOfferId: offer.offerId,
        addonOfferId: followingGapOffer?.offerId!,
        paramName: 'Term'
      }).then(({ data }) => setFollowingGapPossibleTerms(data))
  }, [followingGapOffer?.offerId]);

  useEffect(() => {
    if (replacingGapOffer)
      getAddonParamValues({
        mainOfferId: offer.offerId,
        addonOfferId: replacingGapOffer?.offerId!,
        paramName: 'Term'
      }).then(({ data }) => setNotFollowingGapPossibleTerms(data))
  }, [replacingGapOffer?.offerId]);

  const handleChangeGapType = (value: 'following' | 'replacing') => {
    if (isContracted)
      return;

    setGapType(value)

    const selectedOffer = value == 'following' ? null : replacingGapOffer

    handleSelectAddonOffer(selectedOffer?.offerId, selectedOffer?.params?.parameterValues.find(x => x.name == 'Term')?.value)
      .then(() => recalculate([offer.offerId]))
  }

  const handleSelectAddonOffer = (addonOfferId?: number, term?: string) => {
    setIsLoadingGapOffers(true)
    return selectOfferAddon({ mainOfferId: offer.offerId, addonOfferId, term })
      .then(() => refetchAddonOffers()
        .finally(() => setIsLoadingGapOffers(false)))
  }

  useEffect(() => {
    setCheckedFollowingGap(followingGapOffer?.linkedOfferId?.includes(offer.offerId) ?? false)
  }, [followingGapOffer]);

  useEffect(() => {
    setGapType((replacingGapOffer?.linkedOfferId?.includes(offer.offerId) ?? false) ? 'replacing' : 'following')
  }, [replacingGapOffer]);

  const linkedOfferAddon = allGapOffers.find(x => x.linkedOfferId?.includes(offer.offerId))

  return (
    <Box
      sx={{
        display: { base: 'grid' },
        gridTemplateColumns: { base: '1fr', md: '2fr 1fr' },
        columnGap: 8,
        rowGap: 4,
      }}
    >
      <Box sx={{ display: 'grid', gap: 4, alignContent: 'start' }}>
        {/* POV, HAV */}
        <InsuranceInfo>
          {povPart && <InsuranceInfoItem label="Povinné ručení" name={povPart.name} price={povPart.price} tooltip={povPart.description}
            notAvailable={povPart.notAvailable} emptyChar={povPart.price == undefined && offer.insurerId == Insurer.Allianz ? '' : undefined} />}

          {havPart && <InsuranceInfoItem label="Havarijní pojištění" name={`${havPart.name}${spolPartName ? `, ${spolPartName}` : ''}`} price={havPart.price} tooltip={havPart.description}
            notAvailable={havPart.notAvailable} emptyChar={havPart.price == undefined && offer.insurerId == Insurer.Allianz ? '' : undefined} />}
        </InsuranceInfo>

        {/* doplnky */}
        <ExtraInsurance>
          {isLoadingGapOffers && <Loading large={false} text='Načítám možnosti pojištění GAP...' sx={{
            display: 'flex',
            placeContent: 'start'

          }} />}
          {!isLoadingGapOffers &&
            <>
              {gapPart && !gapVariantSelected &&
                <ExtraInsuranceItem name={gapPart.name} price={gapPart.price} valid={gapPart.valid} errors={gapPart.errors} />}

              {/* Vyber GAPU */}
              {gapPart && gapVariantSelected &&
                <RadioGroup name="gap-type" value={gapType} onChange={handleChangeGapType}>
                  <Box display='grid' rowGap={1}>
                    {/* GAP pojistovny */}
                    <ExtraInsuranceItem name={<Radio value="following" disabled={isContracted}>{gapPart.name}</Radio>}
                      price={gapPart.price}
                      valid={gapPart.valid}
                      errors={gapPart.errors}
                    />

                    {/* navazujici na GAP pojistovny */}
                    {gapPart.valid && followingGapOffer && gapType == 'following' && followingGapPossibleTerms.length > 0 &&
                      <ExtraInsuranceItem
                        name={
                          <Box
                            sx={{
                              display: 'grid',
                              gridTemplateColumns: 'auto auto auto',
                              alignItems: 'center',
                              gap: 2,
                              flexWrap: 'no-wrap',
                              ml: 5
                            }}>

                            <Checkbox sx={{ flexBasis: '100%' }}
                              isChecked={checkedFollowingGap}
                              disabled={isContracted}
                              onChange={e => {
                                setCheckedFollowingGap(e.target.checked)

                                if (e.target.checked)
                                  handleSelectAddonOffer(followingGapOffer?.offerId, followingGapOffer?.params?.parameterValues.find(x => x.name == 'Term')?.value)
                                else
                                  handleSelectAddonOffer()
                              }}
                            >
                              {followingGapOffer.name}
                            </Checkbox>

                            <Select
                              disabled={isContracted}
                              value={followingGapOffer.params?.parameterValues.find(x => x.name == 'Term')?.value}
                              onChange={e => handleSelectAddonOffer(followingGapOffer?.offerId, e.target.value)}
                            >
                              {followingGapPossibleTerms.map(x => <option key={x.value} value={x.value}>{x.text}</option>)}
                            </Select>

                            <Text>- Navazující od {moment(insurancePramsDto.generalParams.insuranceStartDate).add(gapPart.term ?? 0, 'M').format('D.M.YYYY')}</Text>
                          </Box>
                        }
                        price={followingGapOffer.pricePerYear}
                        valid={true}
                        errors={followingGapOffer.errors}
                        editableProps={{
                          isEditable: !!followingGapOffer.priceMin && !!followingGapOffer.priceMax && checkedFollowingGap && !isContracted,
                          priceMin: followingGapOffer.priceMin,
                          priceMax: followingGapOffer.priceMax,
                          price: followingGapOffer.pricePerYear,
                          onChange: (price: number, successAction: () => void, errorAction: (error: string) => void) => {
                            changePrice({ offerId: followingGapOffer!.offerId, price })
                              .then(({ data: updatedOffer }) => {
                                successAction()
                                updateAddonOffer(updatedOffer)
                              }).catch((reason) => {
                                let error = 'Nelze uložit změnu ceny'
                                if (reason.response.status == 400) {
                                  error = reason.response.data
                                }
                                errorAction(error)
                              })
                          },
                          tooltip: defendGapEditPriceTooltip
                        }}
                      />
                    }

                    {/* nahrazujici GAP */}
                    {replacingGapOffer &&
                      <ExtraInsuranceItem key={replacingGapOffer.offerId}
                        name={
                          <Box sx={{
                            display: 'grid',
                            gridTemplateColumns: 'auto auto',
                            alignItems: 'center',
                            gap: 2,
                            flexWrap: 'no-wrap',
                          }}>
                            <Radio value="replacing" disabled={isContracted}>
                              {replacingGapOffer?.name}
                            </Radio>

                            <Select
                              disabled={isContracted}
                              value={replacingGapOffer.params?.parameterValues.find(x => x.name == 'Term')?.value}
                              onChange={e => handleSelectAddonOffer(replacingGapOffer?.offerId, e.target.value)}
                            >
                              {replacingGapPossibleTerms.map(x => <option key={x.value} value={x.value}>{x.text}</option>)}
                            </Select>
                          </Box>
                        }
                        price={replacingGapOffer.pricePerYear}
                        valid={true}
                        errors={replacingGapOffer.errors}
                        editableProps={{
                          isEditable: !!replacingGapOffer.priceMin && !!replacingGapOffer.priceMax && gapType == 'replacing' && !isContracted,
                          priceMin: replacingGapOffer.priceMin,
                          priceMax: replacingGapOffer.priceMax,
                          price: replacingGapOffer.pricePerYear,
                          onChange: (price: number, successAction: () => void, errorAction: (error: string) => void) => {
                            changePrice({ offerId: replacingGapOffer!.offerId, price })
                              .then(({ data: updatedOffer }) => {
                                successAction()
                                updateAddonOffer(updatedOffer)
                              }).catch((reason) => {
                                let error = 'Nelze uložit změnu ceny'
                                if (reason.response.status == 400) {
                                  error = reason.response.data
                                }
                                errorAction(error)
                              })
                          },
                          tooltip: defendGapEditPriceTooltip
                        }}
                      />}
                  </Box>
                </RadioGroup>
              }
              {/* speciální navazujici GAP Allianz */}
              {allianzKaskoWithGapPart && offerVariantWithGap && gapVariantSelected && followingGapOffer && followingGapPossibleTerms.length > 0 &&
                <ExtraInsuranceItem
                  name={
                    <Box
                      sx={{
                        display: 'grid',
                        gridTemplateColumns: 'auto auto auto',
                        alignItems: 'center',
                        gap: 2,
                        flexWrap: 'no-wrap'
                      }}>

                      <Checkbox sx={{ flexBasis: '100%' }}
                        isChecked={checkedFollowingGap}
                        disabled={isContracted}
                        onChange={e => {
                          setCheckedFollowingGap(e.target.checked)

                          if (e.target.checked)
                            handleSelectAddonOffer(followingGapOffer?.offerId, followingGapOffer?.params?.parameterValues.find(x => x.name == 'Term')?.value)
                          else
                            handleSelectAddonOffer()
                        }}
                      >
                        {followingGapOffer.name}
                      </Checkbox>

                      <Select
                        disabled={isContracted}
                        value={followingGapOffer.params?.parameterValues.find(x => x.name == 'Term')?.value}
                        onChange={e => handleSelectAddonOffer(followingGapOffer?.offerId, e.target.value)}
                      >
                        {followingGapPossibleTerms.map(x => <option key={x.value} value={x.value}>{x.text}</option>)}
                      </Select>

                      <Text>- Navazující od {moment(insurancePramsDto.generalParams.insuranceStartDate).add(24, 'M').format('D.M.YYYY')}</Text>
                    </Box>
                  }
                  price={followingGapOffer.pricePerYear}
                  valid={true}
                  errors={followingGapOffer.errors}
                  editableProps={{
                    isEditable: !!followingGapOffer.priceMin && !!followingGapOffer.priceMax && checkedFollowingGap && !isContracted,
                    priceMin: followingGapOffer.priceMin,
                    priceMax: followingGapOffer.priceMax,
                    price: followingGapOffer.pricePerYear,
                    onChange: (price: number, successAction: () => void, errorAction: (error: string) => void) => {
                      changePrice({ offerId: followingGapOffer!.offerId, price })
                        .then(({ data: updatedOffer }) => {
                          successAction()
                          updateAddonOffer(updatedOffer)
                        }).catch((reason) => {
                          let error = 'Nelze uložit změnu ceny'
                          if (reason.response.status == 400) {
                            error = reason.response.data
                          }
                          errorAction(error)
                        })
                    },
                    tooltip: defendGapEditPriceTooltip
                  }}
                />
              }
              {/* speciální nahrazujici GAP Allianz */}
              {allianzKaskoWithoutGapPart && offerVariantWithGap && gapVariantSelected && replacingGapOffer && replacingGapPossibleTerms.length > 0 &&
                <ExtraInsuranceItem
                  name={
                    <Box
                      sx={{
                        display: 'grid',
                        gridTemplateColumns: 'auto auto auto',
                        alignItems: 'center',
                        gap: 2,
                        flexWrap: 'no-wrap'
                      }}>

                      <Checkbox sx={{ flexBasis: '100%' }}
                        isChecked={checkedAllianzReplacingGap}
                        disabled={isContracted}
                        onChange={e => {
                          setCheckedAllianzReplacingGap(e.target.checked)

                          if (e.target.checked)
                            handleSelectAddonOffer(replacingGapOffer?.offerId, replacingGapOffer?.params?.parameterValues.find(x => x.name == 'Term')?.value)
                          else
                            handleSelectAddonOffer()
                        }}
                      >
                        {replacingGapOffer.name}
                      </Checkbox>

                      <Select
                        disabled={isContracted}
                        value={replacingGapOffer.params?.parameterValues.find(x => x.name == 'Term')?.value}
                        onChange={e => handleSelectAddonOffer(replacingGapOffer?.offerId, e.target.value)}
                      >
                        {replacingGapPossibleTerms.map(x => <option key={x.value} value={x.value}>{x.text}</option>)}
                      </Select>
                    </Box>
                  }
                  price={replacingGapOffer.pricePerYear}
                  valid={true}
                  errors={replacingGapOffer.errors}
                  editableProps={{
                    isEditable: !!replacingGapOffer.priceMin && !!replacingGapOffer.priceMax && checkedAllianzReplacingGap && !isContracted,
                    priceMin: replacingGapOffer.priceMin,
                    priceMax: replacingGapOffer.priceMax,
                    price: replacingGapOffer.pricePerYear,
                    onChange: (price: number, successAction: () => void, errorAction: (error: string) => void) => {
                      changePrice({ offerId: replacingGapOffer!.offerId, price })
                        .then(({ data: updatedOffer }) => {
                          successAction()
                          updateAddonOffer(updatedOffer)
                        }).catch((reason) => {
                          let error = 'Nelze uložit změnu ceny'
                          if (reason.response.status == 400) {
                            error = reason.response.data
                          }
                          errorAction(error)
                        })
                    },
                    tooltip: defendGapEditPriceTooltip
                  }}
                />
              }
            </>
          }

          {/* all other parts */}
          {offer.parts
            .filter(x => ![Risk.POV, Risk.HAV, Risk.SPOL, Risk.GAP].includes(x.riskId) && x.included)
            .map(part =>
              <ExtraInsuranceItem key={part.riskId} name={part.parentId ? <Text ml="5">{part.name}</Text> : <>{part.name}</>}
                price={part.price} valid={part.valid} errors={part.errors}
                hidePrice={!!part.parentId || part.price == undefined && offer.insurerId == Insurer.Allianz} />
            )}

        </ExtraInsurance>

      </Box>

      {/* Controls and totals */}
      <ControlsTotals>
        <Controls>
          <FormControl sx={{ gap: 3 }}>
            <Stack direction={'row'}>
              <FormLabel sx={{ fontWeight: 'normal' }}>Frekvence platby</FormLabel>
              {(isFetchingPf || isLoadingPf) && <Spinner />}
            </Stack>

            <Select
              value={offer.paymentFrequencyId}
              disabled={isContracted}
              onChange={(e) => {
                updatePaymentFrequency({
                  offerId: offer.offerId,
                  paymentFrequency: parseInt(e.target.value)
                }).then(() => recalculate([offer.offerId]))
              }}>
              {allowedPf.map((item) => (
                <option value={item.id} key={item.id}>
                  {item.description}
                </option>
              ))}
            </Select>
          </FormControl>

          <Popover>
            <PopoverTrigger>
              <Button variant="outline">
                <Percent color="secondary.500" />
                Slevy
              </Button>
            </PopoverTrigger>

            <PopoverContent>
              <PopoverArrow />

              <PopoverHeader sx={{ fontWeight: '600' }}>Slevy</PopoverHeader>

              <PopoverBody>
                Aplikované slevy
                {discounts?.data
                  .filter(x => (x.discount ?? 0) > 0)
                  .map(x => (<Text key={x.insuranceCategoryDiscountId}>{x.name}: {x.discount}{x.unit}</Text>))}
              </PopoverBody>
            </PopoverContent>
          </Popover>

          <CKPInfo offerId={offer.offerId} />
        </Controls>

        <Totals>
          {/* splatka se spocita na zaklade frekvence platby */}
          <Total label="Splátka" price={offer.price * (parseInt(allowedPf?.find(x => x.id == offer.paymentFrequencyId)?.value ?? '12')) / 12} />
          <Total label="Pojistné za rok" price={offer.price} size="lg" color={color} />
          {linkedOfferAddon && < Total label="GAP Defend" price={linkedOfferAddon.pricePerYear!} />}
        </Totals>
      </ControlsTotals>
    </Box>
  )
}
